import script from "./CartaoDoCatalogo.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDoCatalogo.vue?vue&type=script&setup=true&lang=js"

import "./CartaoDoCatalogo.vue?vue&type=style&index=0&id=5070b4f7&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5070b4f7"]])

export default __exports__